import { useEffect } from 'react';
import { gql, useQuery } from '@apollo/client';

import { useCurrentMemberContext } from 'src/contexts';

export const GET_GANTT_RECORDS_BY_RANGE = gql`
  query getGanttRecordsByRange($payload: GetGanttRecordsByRangeInput!) {
    getGanttRecordsByRange(payload: $payload) {
      _id
      dateString
      recordWorkingHours
      availableWorkingHours
      plannedRecordHours
      employeeId
      date
      entries {
        _id
        type
        groupId
        sourceId
        workingType
        orderPriority
        plannedEntryHours
        startDateString
        startDate
        endDateString
        endDate
        details
        fullDay
      }
    }
  }
`;

export const GANTTS_RECORDS_CHANGED_SUBSCRIPTION = gql`
  subscription ganttsRecordsChanged($payload: GetGanttRecordsByRangeInput!) {
    ganttsRecordsChanged(payload: $payload) {
      trigger
      ganttRecord {
        _id
        dateString
        recordWorkingHours
        availableWorkingHours
        employeeId
        entries {
          _id
          type
          groupId
          sourceId
          workingType
          orderPriority
          plannedEntryHours
          startDateString
          startDate
          endDateString
          endDate
          details
          fullDay
        }
      }
    }
  }
`;

export const useGetGanttRecordsByRangeForActiveGantt = ({ startDate, endDate }: any) => {
  const { ganttId } = useCurrentMemberContext();
  const { data, loading, subscribeToMore } = useQuery(GET_GANTT_RECORDS_BY_RANGE, {
    variables: { payload: { ganttId, startDate, endDate } },
    fetchPolicy: 'network-only',
  });

  useEffect(() => {
    if (ganttId) {
      subscribeToMore({
        document: GANTTS_RECORDS_CHANGED_SUBSCRIPTION,
        variables: { payload: { ganttId, startDate, endDate } },
        updateQuery: (prev, { subscriptionData }) => {
          if (!subscriptionData.data) return prev;

          const { trigger, ganttRecord } = subscriptionData.data?.ganttsRecordsChanged || {};

          const ganttRecords = prev?.getGanttRecordsByRange || [];
          const newGanttRecords = [...ganttRecords];
          const findIndex = ganttRecords.findIndex((value: any) => value._id === ganttRecord._id);

          if (trigger === 'ganttRecordCreated' && findIndex < 0) {
            newGanttRecords.push(ganttRecord);
          }

          if (findIndex > -1) {
            if (trigger === 'ganttRecordRemoved') {
              newGanttRecords.splice(findIndex, 1);
            }

            if (trigger === 'ganttRecordUpdated') {
              newGanttRecords[findIndex] = ganttRecord;
            }
          }

          return { getGanttRecordsByRange: newGanttRecords };
        },
      });
    }
  }, [ganttId, startDate, endDate, subscribeToMore]);

  return { loading, ganttRecords: data?.getGanttRecordsByRange || {} };
};
